import type { ReactNode } from 'react';

import styles from './order-detail.module.scss';

/** A label/value row used in the Order Details and Logistics cards. */
export function OrderMetaRow({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className={styles.metaRow}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
}
